import React from 'react';
// Components
import ManageAmaRequests from 'components/common/ManageAmaRequests';

const ManageContentCreatorAmaRequests: React.FC = () => {
  return <ManageAmaRequests />;
};

export default ManageContentCreatorAmaRequests;
